/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import _ from 'lodash'
import { Button, Box, Badge } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import SpinnerLoading from '../../../../components/Loading/SpinnerLoading'
import { useTranslation } from 'react-i18next'
import BackButton from 'components/Button/BackButton'
import { useParams, useHistory, Link } from 'react-router-dom'
import * as actions from '../../../../redux/actions'
import UserRoles from '../../../../config/UserRoles'
import { Chip } from '@mui/material'

export default function ListDiagramGroup() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const [currentStation, setCurrentStation] = useState()
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => {})
    return () => {}
  }, [params])

  useEffect(() => {
    if (allStations) {
      const tempcurrentStatus = _.find(
        allStations.arr,
        (station) => station._id === params.id
      )
      setCurrentStation(tempcurrentStatus)
      setIsLoading(true)
      console.log('Curent Station', currentStation)
    }
    return () => {}
  }, [params, allStations])

  const renderGaugeSelect = (gauge, status) => {
    const checkNull = []
    if (status === 'GAUGE') {
      _.map(gauge, (gg, index) => {
        checkNull.push(
          _.filter(currentStation?.gauges, (g, index) => g?._id === gg)
        )
      })
      return _.map(checkNull, (gg, index) => {
        return index < 3 ? (
          <Chip className="mx-2" size="small" label={gg[0]?.gaugeLabel} />
        ) : index > 3 && index < 5 ? (
          <Chip className="mx-2" size="small" label={'...'} />
        ) : (
          <></>
        )
      })
    } else if (status === 'CHART') {
      _.map(gauge, (gg, index) => {
        checkNull.push(
          _.filter(currentStation?.charts, (g, index) => g?._id === gg)
        )
      })
      return _.map(checkNull, (gg, index) => {
        return index < 3 ? (
          <Chip className="mx-2" size="small" label={gg[0]?.chartLabel} />
        ) : index > 3 && index < 5 ? (
          <Chip className="mx-2" size="small" label={'...'} />
        ) : (
          <></>
        )
      })
    } else if (status === 'DIAGRAM') {
      _.map(gauge, (gg, index) => {
        checkNull.push(
          _.filter(currentStation?.diagrams, (g, index) => g?._id === gg)
        )
      })
      return _.map(checkNull, (gg, index) => {
        return index < 3 ? (
          <Chip className="mx-2" size="small" label={gg[0]?.diagramName} />
        ) : index > 3 && index < 5 ? (
          <Chip className="mx-2" size="small" label={'...'} />
        ) : (
          <></>
        )
      })
    }
  }

  const genGroupList = () => {
    return _.map(currentStation?.groups, (group, index) => (
      <Box borderRadius="lg" padding="4" className="bg-white my-2 ">
        <div className="flex gap-3">
          <div className="w-5/6">
            <h5 className="text-lg font-bold font-sans">
              {group?.groupName}
              <Badge colorScheme="teal" size="sm">
                {/* {gaugeData?.sensorType} */}
              </Badge>
            </h5>
          </div>

          <Link
            to={
              '/system/stations/diagram/order-diagram/' +
              group._id +
              '/' +
              currentStation._id
            }
          >
            <Button colorScheme="yellow" variant="solid" size="sm">
              จัดเรียงแผนผัง
            </Button>
          </Link>
        </div>

        <p className="text-sm ">
          {' '}
          <span className="text-sm font-semibold text-gray-700">
            {'ชื่อกลุ่ม : '}
          </span>{' '}
          {group?.groupName}{' '}
        </p>

        <span className="text-sm font-semibold text-gray-700">
          {'คำอธิบาย'} :{' '}
        </span>
        <span className="text-sm font-semibold text-gray-700">
          {group?.description}
        </span>

        <ul>
          <li>
            <span className="text-sm font-semibold text-gray-700">
              {'สิทธิการเข้าถึง : '}
            </span>
            <span className="text-sm font-semibold text-blue-700">
              {group?.role === UserRoles.ROLES.USER
                ? 'พนักงานทั่วไป ขึ้นไป'
                : group?.role === UserRoles.ROLES.ADMIN
                ? 'พนักงานระดับหัวหน้า ขึ้นไป'
                : group?.role === UserRoles.ROLES.MANAGER
                ? 'ผู้จัดการ'
                : 'ผู้ดูแลระบบ'}
            </span>
          </li>
        </ul>

        <span className="text-sm font-semibold text-gray-700">
          {'ตัวอย่างแผนผัง : '}
          {renderGaugeSelect(group?.diagram, 'DIAGRAM')}
        </span>
      </Box>
    ))
  }

  if (currentStation && isLoading) {
    return (
      <div>
        <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h2 className="text-gray-800 text-2xl font-bold font-sans">
                  {t('arrangement.manageFlowchartArrangement')}{' '}
                  {currentStation.name}
                </h2>
              </div>
            </div>
            <Button>
              <BackButton />
            </Button>
          </div>
          <div className="p-4 w-full">{genGroupList()}</div>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
